<template>
<div>
    <confirm body="Do you want to pay with a card?" title="Pay with New Card" @yes="startAddFunds" :showButton="trueParam"  buttonclass="button buttonpay"/>
    
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            

                <div v-if="!showConfirm">
                    <form ref="addfundsform">
                        <label class="titlelabel">Pay with Card</label>
                        <br/>
               
                        <formentry inputid="amount"  inputtype="number" :isrequired='trueParam' label="Amount to Add"  v-model="FundRequest.Amount" />
            
                        <smallbutton  @click="GetTax()" toplabel="Calc Tax and Fee"/>
                        <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                        <div v-if="!showConfirm">
                            <label class="responsemessage">{{responseMessage}}</label>
                        </div>
                    </form>
                </div>
                <div v-if="showConfirm">
                    <form>
                        <div class="vertFlex">
                            <label class="subtitleBold">Confirm Amount</label>
                            <br/>
            
                            <label class="listtextbold">
                                Amount: {{FundRequest.Amount | toCurrency}}
                            </label>
                            <label class="listtextbold" v-if="FundRequest.TaxAmount!='0'">
                                Tax: {{FundRequest.TaxAmount | toCurrency}}
                            </label>
                            <label class="listtextbold" v-if="FundRequest.FeeAmount!='0'">
                                Service Fee: {{FundRequest.FeeAmount | toCurrency}}
                            </label>
                            <label class="listtextbold" >
                                Total: {{TotalAmount | toCurrency}}
                            </label>
                         </div>
                         <smallbutton  @click="submitFunds()" toplabel="Go to Enter Card" :disabled="disableSubmit" v-if="!iscomplete"/>
                        <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel" v-if="!iscomplete"/>
                        <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" v-if="iscomplete"/>
                        <div>
                            <label class="responsemessage">{{responseMessage}}</label>
                        </div>
                    </form>
                </div>
                
            
            
        </template>
      </actionmodal>

      
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import confirm from './confirm.vue'
export default {
    name:'notokensale',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        confirm
    },
    props:{
        account:{
            type:Object,
            required:true
        }
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            trueParam:true,
            responseMessage:'',
            pleaseWait:false,

            FundRequest:{
                ID:0,
                Name:'',
                TokenID:0,
                Amount:'',
                FeeAmount:0,
                TaxAmount:0
            },
            showConfirm:false,
            disableSubmit:false,
            iscomplete:false,
        }
    },
    computed:{
        TotalAmount(){
            return this.FundRequest.FeeAmount + this.FundRequest.TaxAmount + this.FundRequest.Amount
        },
        ...mapFields([
            'currentWallet'

        ]),

 
       
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
        startAddFunds(){
            this.iscomplete=false
            this.responseMessage=''
            this.FundRequest.ID=this.account.ID
            this.FundRequest.Name=this.account.Name

            this.FundRequest.TokenID=0
            this.FundRequest.Amount=''
            this.FundRequest.FeeAmount=0
            this.FundRequest.TaxAmount=0
            


            this.showConfirm=false
            this.disableSubmit=false
            this.$refs.mymodal.openModal()
            
        },

    async calcFees(){
        if(this.$refs.addfundsform.checkValidity()){
            //validate amt
            if(this.LimitToDue){
                if(Number(this.FundRequest.Amount)> Number(this.account.amountDue)){
                    console.log('toomuch')
                    this.responseMessage="Please enter an amount less than or equal to the amount due."
                    return
                }
            }


            this.beforeAPI();
            let req = {
                initialAccountFundList:[this.FundRequest]
            }
            var response = await this.callAPI(req,'getfee')
            
            
            if(response.Successful){
                this.showConfirm=true
                this.FundRequest=response.initialAccountFundList[0]
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        }
    },
    async GetTax(){
 
        //create req
        let req = {
            Product:{
                id:-1,
                price:this.FundRequest.Amount
            }
            
        }
        //call
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'gettax')
        //handle response
        if(response.Successful){
            var taxamount = response.responseDouble
            console.log(taxamount)
            //add the tax to the record  
            this.FundRequest.TaxAmount=taxamount
            
        
            this.calcFees();//now we can add the fees!
        }else{
            this.message = response.Message
        }
        this.pleaseWait=false;
        },
    async submitFunds(){
      var windowReference = window.open('about:blank','_blank');

      console.log("submit funds")
      this.disableSubmit=true;
      this.beforeAPI();
      let req = {
            initialAccountFundList:[this.FundRequest]
        }
      var response = await this.callAPI(req,'notokensale')

       if(response.Successful){
            this.iscomplete=true

                windowReference.location=response.url;
                this.$refs.mymodal.closeModal()
            }else{
                this.message = response.Message
                windowReference.close()
            }
      this.pleaseWait=false;
      
    },
    cancelConfirm(){
      this.showConfirm=false

    },
    clearFundRequest(){
      this.FundRequest={
        ID:0,
        Name:'',
        TokenID:0,
        Amount:'',
        FeeAmount:0
      }
    },
    
       
        
    }
}
</script>

<style>

</style>





























